import { motion } from "framer-motion";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function PageHeader({ eyebrow, title, subtitle, image, trail }) {
  return (
    <section className="relative overflow-hidden pt-28 md:pt-32" data-testid="page-header">
      {image && (
        <>
          <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-brand-obsidian/80 via-brand-obsidian/70 to-brand-obsidian" />
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-24">
        {trail && <div className="mb-6"><Breadcrumbs trail={trail} /></div>}
        {eyebrow && <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">{eyebrow}</p>}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 max-w-4xl font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl lg:text-8xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.7 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 md:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
